// File for logic corresponding to newsroom footer component
import './assets/newsroom-footer.css';
